// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191035/js/" + chunkId + "." + {"44":"94d7d160","225":"c91a05c3","481":"6a20668f","486":"4210167c","770":"330dc407"}[chunkId] + ".0.08978426211059798.chunk.js";
};